import { Button, Heading } from '@assembly-js/design-system';
import { FieldArray } from 'formik';

import {
  URLQueryParamFormField,
  URLQueryParamsPreview,
} from './SetupEmbedURLQueryParams';

export type URLQueryParam = { key: string; value: string };

interface URLQueryParamsSectionProps {
  queryParams: URLQueryParam[];
  content?: string;
  setFieldValue: (field: string, value: unknown) => void;
}

export function URLQueryParamsSection({
  queryParams,
  content,
  setFieldValue,
}: URLQueryParamsSectionProps) {
  return (
    <>
      <div className="border-0 border-b border-solid border-non-hover-border py-6 mb-6">
        <Heading size="lg">URL parameters</Heading>
      </div>

      <div className="mb-6">
        <FieldArray name="queryParams">
          {({ replace, remove }) => (
            <URLQueryParamFormField replace={replace} remove={remove} />
          )}
        </FieldArray>

        <Button
          prefixIcon="Plus"
          onClick={() => {
            setFieldValue('queryParams', [
              ...queryParams,
              { key: '', value: '' },
            ]);
          }}
          label="Add parameter"
          className="mb-6"
          variant="text"
        />

        <URLQueryParamsPreview
          queryParams={queryParams}
          content={content ?? ''}
        />
      </div>
    </>
  );
}
